import { Action, ActionType, PageLoadedData } from "app/pages/Products/actionTypes";
import { ProductsListState } from './state'
import { FETCH_INTENSITY_LIST, SET_INTENSITY_LIST, FETCH_SCHOOL_CONFIGS, SET_SCHOOL_CONFIGS } from './actions';

const startingState: ProductsListState = {
    types: {},
    searchTerm: '',
    selectedProductType: 'Accommodation',
    data: undefined,
    filteredData:[],
    accommodationProducts:[],
    courseProducts:[],
    addOnProducts:[],
    transferProducts:[],
    courseProduct: undefined,
    courseIntensity:[],
    productDivisions:[],
    name:'',
    intensityId:0,
    divisionId:0,
    accommodation:undefined,
    transfer:undefined,
    addon:undefined,
    formErrors: [],
    accommodationTypes:[],
    unitTypes:[],
    transferTypes:[],
    transferPorts:[],
    intensityList: [],
    intensityLoading: false,
    schoolConfigs: [],
    schoolConfigsLoading: false
}

export function reducer(state: ProductsListState|undefined, action: any) : ProductsListState {
    if(!state)
        return startingState;

    switch(action.type){
        case FETCH_INTENSITY_LIST:
            return { ...state, intensityLoading: true };
        case SET_INTENSITY_LIST:
            return { ...state, intensityList: action.payload, intensityLoading: false };
        case FETCH_SCHOOL_CONFIGS:
            return { ...state, schoolConfigsLoading: true };
        case SET_SCHOOL_CONFIGS:
            return { ...state, schoolConfigs: action.payload, schoolConfigsLoading: false };
        case ActionType.PageLaded:
            return { ...startingState, courseIntensity:action.courseIntensity ?? [],productDivisions:action.productDivisions ?? [],formErrors: action.formErrors ?? [],accommodationTypes:action.accommodationTypes ?? [],unitTypes:action.unitTypes ?? [],transferTypes:action.transferTypes ?? [],transferPorts:action.transferPorts ?? []};
        case ActionType.ChangeSelectedProductType:
            return { ...state, selectedProductType: action.selectedProductType};
        case ActionType.ChangeSearchTerm:
            return {...state, searchTerm: action.searchTerm};
        case ActionType.FilterData:
            return {...state, filteredData: action.filteredData};
        case ActionType.ListAccommodationProductsData:
            return {...state, accommodationProducts: action.accommodationProducts};
        case ActionType.ListCoursesData:
            return {...state, courseProducts: action.courseProducts};
        case ActionType.GetCourseProductData:
            return {...state, courseProduct: action.courseProduct};
        case ActionType.ListAddOns:
            return {...state, addOnProducts: action.addOnsProducts};
        case ActionType.ListTransfers:
            return {...state, transferProducts: action.transferProducts};
        case ActionType.SetCourseProductIntensity:
            return {...state, intensityId: action.id};
        case ActionType.SetCourseProductName:
            return {...state, name: action.name};
        case ActionType.SetCourseDivision:
            return {...state, divisionId: action.id};
        case ActionType.GetCourseProductName:
            return {...state, name: action.name};
        case ActionType.GetAccommodationProduct:
            return {...state, accommodation: action.accommodation,draftProduct:action.accommodation};
        case ActionType.GetTransferProduct:
            return {...state, transfer: action.transfer};
        case ActionType.GetAddonProduct:
            return {...state, addon: action.addon};
        case ActionType.CancelShowDeleteCourseAction:
            return {...state,courseProduct: undefined};
        case ActionType.CancelShowDeleteAccommodationAction:
            return {...state,accommodation: undefined};
        case ActionType.SetFormErrors:
            return { ...state, formErrors: action.formErrors};
        case ActionType.UpdateDraftAccommodationProduct:  
                return { ...state, draftProduct: action.draftProduct};            
        case ActionType.LoadDraftAccommodationProduct:
            return { ...state, draftProduct: action.draftProduct};
        case ActionType.CancelShowDeleteAddOnAction:
            return {...state,addon: undefined};
        case ActionType.UpdateDraftAddOnProduct:  
            return { ...state, draftAddOnProduct: action.draftProduct};            
        case ActionType.LoadDraftAddOnProduct:
            return { ...state, draftAddOnProduct: action.draftProduct};
        case ActionType.UpdateDraftTransferProduct:  
            return { ...state, draftTransferProduct: action.draftProduct};            
        case ActionType.LoadDraftTransferProduct:
            return { ...state, draftTransferProduct: action.draftProduct};
        default:
            return state;
    }
}

export const reducers = {
    reducer
};